import { Injectable } from '@angular/core';
import {
    CTAPIConfiguration,
    CustomerRest,
    AddressRest,
    PartRest,
    InsuranceRest,
    OrderRest,
    ReasonRest,
    AccountRest,
    MaterialOrderRest,
    GeoProxyRest
} from '@ct-client';
import { SecretService } from './secret.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class APIService {

    private tokenInUse: string = null;

    private controlTowerApiConfig: CTAPIConfiguration = null;
    private controlTowerCustomerService: CustomerRest = null;
    private controlTowerAddressService: AddressRest = null;
    private controlTowerPartsService: PartRest = null;
    private controlTowerInsuranceService: InsuranceRest = null;
    private controlTowerOrdersService: OrderRest = null;
    private controlTowerMaterialOrderService: MaterialOrderRest = null;
    private controlTowerReasonsService: ReasonRest = null;
    private controlTowerAccountService: AccountRest = null;
    private controlTowerGeoProxyService: GeoProxyRest = null;

    constructor(private secretService: SecretService, private httpClient: HttpClient) { }

    public setCTAPIConfigurations() {
        if (!this.tokenInUse || this.tokenInUse !== this.secretService.getToken()) {
            this.tokenInUse = this.secretService.getToken();
            this.controlTowerApiConfig = new CTAPIConfiguration(
                this.secretService.getConfiguration().ctUrl, this.secretService.getToken(), this.httpClient
            );
            this.controlTowerCustomerService = new CustomerRest(this.controlTowerApiConfig);
            this.controlTowerAddressService = new AddressRest(this.controlTowerApiConfig);
            this.controlTowerPartsService = new PartRest(this.controlTowerApiConfig);
            this.controlTowerInsuranceService = new InsuranceRest(this.controlTowerApiConfig);
            this.controlTowerOrdersService = new OrderRest(this.controlTowerApiConfig);
            this.controlTowerReasonsService = new ReasonRest(this.controlTowerApiConfig);
            this.controlTowerAccountService = new AccountRest(this.controlTowerApiConfig);
            this.controlTowerMaterialOrderService = new MaterialOrderRest(this.controlTowerApiConfig);
            this.controlTowerGeoProxyService = new GeoProxyRest(this.controlTowerApiConfig);
        }
    }

    public isCTAPIConfigurationsAvailable() {
        return !!this.controlTowerApiConfig
            && !!this.controlTowerCustomerService;
    }

    public getControlTowerCustomerService(): CustomerRest {
        return this.controlTowerCustomerService;
    }

    public getControlTowerAddressService(): AddressRest {
        return this.controlTowerAddressService;
    }

    public getControlTowerPartsService(): PartRest {
        return this.controlTowerPartsService;
    }

    public getControlTowerInsuranceService(): InsuranceRest {
        return this.controlTowerInsuranceService;
    }

    public getControlTowerOrderService(): OrderRest {
        return this.controlTowerOrdersService;
    }

    public getControlTowerReasonService(): ReasonRest {
        return this.controlTowerReasonsService;
    }

    public getControlTowerAccountService(): AccountRest {
        return this.controlTowerAccountService;
    }

    public getControlTowerMaterialOrderService(): MaterialOrderRest {
        return this.controlTowerMaterialOrderService;
    }

    public getControlTowerGeoProxyService(): GeoProxyRest {
        return this.controlTowerGeoProxyService;
    }
}
